/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import { Button, FormControl, Grid, InputAdornment } from '@mui/material';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import { BsSearch } from 'react-icons/bs';
import { getAllUsers, getUser } from '../../../../../../store/reducers/user/userAction';

const SearchAdminUser = () => {
    const dispatch = useDispatch()
    const search =  ({username}) => {
        dispatch(getUser({ offset: 0, limit: 100, skip: 0, where: { username } }));
    }

    const clear = ({resetForm})=>{
        dispatch(getAllUsers({
            "offset": 0,
            "limit": 100,
            "skip": 0,
            "order": "desc",
           
            "fields": {
                "adminid": true,
                "username": true,
                "lastname": true,
                "firsttname": true,
                "email": true,
                "cellphone": true,
                "cellphonevalidated": true,
                "useravatar": true
            }
          }));
        resetForm();
    }
    return (
        <> <Formik
            initialValues={{
                username: ''
            }}
            validationSchema={Yup.object().shape({
                username: Yup.string().min(6).max(24).required('Username is required.')
            })}
            onSubmit={(
                values
            ) => {
                search(values)
            }
            }
        >
            {({ resetForm, values, handleBlur, handleChange }) => (
                <Form>

                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6} sm={6}>

                            <FormControl fullWidth >
                                <Field
                                    name="username"
                                    label="Search By User Name"
                                    type="text"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.username}
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    component={TextField}
                                    InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end"  >
                                           
                                            <BsSearch />
                                          </InputAdornment>
                                        ),
                                      }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6} sm={6}>
                            <Button variant="contained" color="primary" type="submit" style={{ marginTop: '20px' }}>Search</Button>
                            <Button variant="outlined" onClick={() => clear({resetForm}) } style={{ marginTop: '20px', marginLeft: '10px' }}>clear</Button>

                        </Grid>

                    </Grid>
                </Form>
            )}
        </Formik>
        </>
    )

}

 
 
export default SearchAdminUser;
